import React from "react";
import {
  escapeRegExp,
  getKeywordsForActivityItem,
} from "./pgHomeActivityText";

export function renderHighlightedActivityText(text, item) {
  const keywords = getKeywordsForActivityItem(item);
  if (!keywords.length || !text) return text;
  const pattern = new RegExp(`(${keywords.map(escapeRegExp).join("|")})`, "gi");
  const parts = String(text).split(pattern);
  const keywordSet = new Set(keywords.map((k) => k.toLowerCase()));
  let offset = 0;
  return parts.map((part) => {
    const key = `${offset}-${part}`;
    offset += part.length;
    return keywordSet.has(String(part).toLowerCase()) ? (
      <strong key={key}>{part}</strong>
    ) : (
      <React.Fragment key={key}>{part}</React.Fragment>
    );
  });
}
